import React, { memo, useCallback, useState, useMemo } from 'react'
import { getCurrentCollectDataStep } from 'src/selectors/collectData'
import { useSelector } from 'react-redux'
import { BGCYardstik } from 'src/components/bgc/BGCYardstik'
import { BGCManualUpload } from 'src/components/bgc/BGCManualUploadForm'
import { SecureWrapper } from '../layout/SecureWrapper'
import { BGCCollectDataStep } from 'src/interfaces/collectData'
import { BGCOption, BGCOptionType } from './types'
import { yardstikOption, manualOption, skipOption } from './constants'
import { BGCSelectOption } from './BGCSelectOption'

const BGCComponent = () => {
  const currentStep = useSelector(getCurrentCollectDataStep) as BGCCollectDataStep

  const [selectedOptionType, setSelectedOptionType] = useState<BGCOptionType | undefined>(undefined)

  const options = useMemo(() => {
    const res: BGCOption[] = []

    if (currentStep.metadata?.enableYardstik) {
      res.push(yardstikOption)
    }

    if (currentStep.metadata?.enableManualUpload) {
      res.push(manualOption)
    }

    if (currentStep.optional) {
      res.push(skipOption)
    }

    return res
  }, [currentStep.metadata, currentStep.optional])

  const selectedOption = useMemo(() => {
    if (options.length === 1) {
      return options[0].value
    }

    return selectedOptionType
  }, [options, selectedOptionType])

  const handleBackToMainPage = useCallback(() => {
    setSelectedOptionType(undefined)
  }, [])

  return (
    <SecureWrapper
      onBack={!!selectedOption && options.length > 1 ? handleBackToMainPage : undefined}
    >
      {(!selectedOption || selectedOption === 'skip') && (
        <BGCSelectOption
          options={options}
          selectedOption={selectedOption}
          onSelect={setSelectedOptionType}
        />
      )}
      {selectedOption === 'yardstik' && <BGCYardstik />}
      {selectedOption === 'manual' && (
        <BGCManualUpload
          hideStepsCounter={options.length > 1}
          isYardstikEnabled={options.some((item) => item.value === 'yardstik')}
        />
      )}
    </SecureWrapper>
  )
}

export const BGC = memo(BGCComponent)
